"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const sliceTemplate_1 = require("../../../../slice/sliceTemplate");
const constants_1 = require("../../../../slice/sliceTemplate/constants");
const store_1 = require("../../../../store");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const PermissionSelects = () => {
    const { usersView, officesView, brandCategoriesView, brandsView, usersEdit } = (0, react_redux_1.useSelector)((state) => state.template);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const handleChangePermission = (type, values) => {
        if (values && values.length) {
            dispatch((0, sliceTemplate_1.updatePermission)({
                permissionType: type,
                value: values.map((item) => {
                    return {
                        value: item.value,
                        label: item.label,
                    };
                }),
            }));
        }
        else if (type !== constants_1.PERMISSION_TYPE.userView &&
            type !== constants_1.PERMISSION_TYPE.userEdit) {
            dispatch((0, sliceTemplate_1.updatePermission)({
                permissionType: type,
                value: [],
            }));
        }
    };
    const selectPermissionClasses = {
        root: styles_modules_less_1.default['permission-select__users-view'],
        selectContainer: styles_modules_less_1.default['permission-select__select-container'],
        label: styles_modules_less_1.default['permission-title'],
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_modules_less_1.default['template-settings-modal__info'] },
            react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['template-info__icon'], 'fal fa-info-circle') }),
            react_1.default.createElement("p", { className: styles_modules_less_1.default['template-info__message'] }, "Choose your permissions settings for this template below. Please note the choices made are accumulative between Users, Groups, Brands and Offices.")),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['template-settings-modal__select'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['template-settings-modal__select--row'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['permission-select__container'] },
                    react_1.default.createElement(pulse_components_1.PulseProjectUsersSelect, { isClearable: false, labelName: "VIEW Permissions: Users", classes: {
                            selectOptionLabel: usersView.length <= 1 &&
                                styles_modules_less_1.default['select-user__selectOptionLabel--hideRemoveIcon'],
                            ...selectPermissionClasses,
                        }, placeholder: "Select users for view only access to the review template", value: usersView, changeHandler: (values) => {
                            handleChangePermission(constants_1.PERMISSION_TYPE.userView, values);
                        }, insideModal: true, isMulti: true, variant: "select2", labelIcon: {
                            icon: 'fal fa-info-circle',
                            tippyDescription: 'These users will have the ability to view  the template and will be able to apply this template to a review',
                            TippyProps: {
                                placement: 'top',
                            },
                        } })),
                react_1.default.createElement("div", { className: styles_modules_less_1.default['permission-select__container'] },
                    react_1.default.createElement(pulse_components_1.PulseClientsSelect, { isClearable: false, labelName: "View Permissions: Offices", labelIcon: {
                            icon: 'fal fa-info-circle',
                            tippyDescription: 'Users from the selected offices can use the template to create reviews',
                            TippyProps: {
                                placement: 'top',
                            },
                        }, classes: selectPermissionClasses, isMulti: true, value: officesView, placeholder: "Select offices for view only access to the review template", valueChangeHandler: (values) => {
                            handleChangePermission(constants_1.PERMISSION_TYPE.officeView, values.officeid);
                        }, insideModal: true, variant: "select2" }))),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['template-settings-modal__select--row'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['permission-select__container'] },
                    react_1.default.createElement(pulse_components_1.PulseBrandCategoriesSelect, { isClearable: false, labelName: "View Permissions: BRANDS CATEGORIES", labelIcon: {
                            icon: 'fal fa-info-circle',
                            tippyDescription: 'Projects created for the selected brand will have the ability to view and use the template',
                            TippyProps: {
                                placement: 'top',
                            },
                        }, classes: selectPermissionClasses, isMulti: true, value: brandCategoriesView, placeholder: "Select brand categories for view-only access to the review template", valueChangeHandler: (values) => {
                            handleChangePermission(constants_1.PERMISSION_TYPE.brandCategoriesView, values);
                        }, insideModal: true, variant: "select2" })),
                react_1.default.createElement("div", { className: styles_modules_less_1.default['permission-select__container'] },
                    react_1.default.createElement(pulse_components_1.PulseBrandsSelect, { isClearable: false, labelName: "View Permissions: BRANDS", labelIcon: {
                            icon: 'fal fa-info-circle',
                            tippyDescription: 'Projects created for the selected brand will have the ability to view and use the template',
                            TippyProps: {
                                placement: 'top',
                            },
                        }, classes: selectPermissionClasses, isMulti: true, value: brandsView, placeholder: "Select brands for view only access to the review template", valueChangeHandler: (values) => {
                            handleChangePermission(constants_1.PERMISSION_TYPE.brandView, values.brandid);
                        }, insideModal: true, variant: "select2" }))),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['template-settings-modal__select--row'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['permission-select__container'] },
                    react_1.default.createElement(pulse_components_1.PulseProjectUsersSelect, { isClearable: false, labelName: "Edit Permissions: Users", labelIcon: {
                            icon: 'fal fa-info-circle',
                            tippyDescription: "These users will have the ability to view  the template and will be able to make changes to this template's view and access settings",
                            TippyProps: {
                                placement: 'top',
                                popperOptions: {
                                    strategy: 'fixed',
                                },
                            },
                        }, classes: {
                            selectOptionLabel: usersEdit.length <= 1 &&
                                styles_modules_less_1.default['select-user__selectOptionLabel--hideRemoveIcon'],
                            ...selectPermissionClasses,
                        }, placeholder: "Select users for view only access to the review template", value: usersEdit, changeHandler: (values) => {
                            handleChangePermission(constants_1.PERMISSION_TYPE.userEdit, values);
                        }, insideModal: true, isMulti: true, variant: "select2" }))))));
};
exports.default = PermissionSelects;
